import { Error } from '@auth0/auth0-acul-js';

import { notify } from '@page/core/services/notifications';

export const ERROR_CODE_MESSSAGE_MAPPING: Record<string, string | undefined> = {
  'wrong-email-credentials': 'Invalid email or password',
  'auth0-users-validation': 'Something went wrong. Please try with a different input.',
  'invalid-code': 'The code you entered is invalid.',
};

export const notifyErrors = (errors: Error[]) => {
  errors.forEach((error) => {
    const errorCode = error.code;
    const errorMessage = errorCode ? ERROR_CODE_MESSSAGE_MAPPING[errorCode] : undefined;

    notify('Error', errorMessage || 'Something went wrong. Please try again.');

    console.error(error);
  });
};

export const hasAuth0UserValidationError = (errors: Error[]) => {
  return errors.some((error) => error.code === 'auth0-users-validation');
};
